import { useCallback, useRef } from 'react';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { IconButton } from '@mui/material';

import { LineType } from '../models/enums/LineType';
import { useMapStore } from '../stores/useMapStore';
import { useSeismicStore } from '../stores/useSeismicStore';
import { CalculateXPositionWithIncrement } from '../utils/calculateScreenValuesUtils';
import { getParamsFromUrl } from '../utils/seismicUrlUtils';
import { useLine3DNavigationStore } from '../stores/useLine3DNavigationStore';

export const ResetViewButton = () => {
    const map = useMapStore(state => state.map);
    const { metadata, calculator, isInverted, scale, traceRange } = useSeismicStore(state => ({
        isInverted: state.isInverted,
        calculator: state.calculator,
        metadata: state.surveyMetadata,
        scale: state.scale,
        traceRange: state.rangeTrace,
    }));
    const lineType = useLine3DNavigationStore(state => state.lineType);

    const resetView = useCallback(() => {
        if (!!metadata && !!calculator) {
            const surveyLineStart = calculator.getMinTrace(metadata);
            const surveyLineEnd = calculator.getMaxTrace(metadata);
            const lineIncrement = calculator.getLineIncrement(metadata);

            const extent = calculator.calculateExtent(metadata, { x: scale.x, y: scale.y }, traceRange);
            const center = calculator.calculateCenter(extent, metadata, { x: scale.x, y: scale.y }, traceRange);

            const defaultTraceToShow = lineType === LineType.Inline && !!metadata.Survey3DInfo.DefaultTraceToShow ? metadata.Survey3DInfo.DefaultTraceToShow : surveyLineStart + (surveyLineEnd / lineIncrement / 2);
            const defaultTraceToShowX = CalculateXPositionWithIncrement(defaultTraceToShow, surveyLineStart, surveyLineEnd, lineIncrement,
                surveyLineStart, isInverted, scale.x);
            const view = map?.getView();
            if (!!view) {
                view.setCenter([defaultTraceToShowX, center[1]]);
                view.setResolution(view.getMaxResolution());
            }
        }
    }, [calculator, isInverted, lineType, map, metadata, scale.x, scale.y, traceRange]);

    return (
        <IconButton onClick={resetView} color='inherit' title='Reset view'>
            <RestartAltIcon/>
        </IconButton>
    );
};